import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectInput from '../../base/inputs/SelectInput';
import TravelerFormQuestionContainer from '../../base/TravelerFormQuestionContainer';
import userId from '../../../../../shared/helpers/userId';
import { addIntakeQuestions, addAdminIntakeFormData } from '../../../actions/intakeFormActions';

export default function IntakeVeteranStatus(props) {
  const dispatch = useDispatch();
  const intake = useSelector(state => state.intakeForm);
  const adminIntakeFormData = intake.adminIntakeFormData;
  const [value, setValue] = useState([]);
  const [error, setError] = useState('');
  const [disabled, setDisabled] = useState(false);

  const question = {
    overline: 'Veteran Status',
    heading: 'Are you a veteran?',
    subheading: 'Select one option.',
    isRequired: intake?.intakeQuestions?.find(item=>item.identifier=="veteran_status").required ?? false,
  };
  
  const options = [
    {label:"Yes",value:"yes"},
    {label:"No",value:"no"},
  ]

  useEffect(
    () => {
      if(props?.isAdmin) {
        const initialValue = options.filter(item => adminIntakeFormData?.veteran_status===item.value);
        setValue(initialValue);
      } else {
        const initialValue = options.filter(item => intake.veteran_status===item.value);
        setValue(initialValue);
      }
      setDisabled(intake.ssoTraveler && intake.readonly.includes('veteran_status'));
    },
    [intake, adminIntakeFormData],
  );

  const handleNext = () => {
    
    setError("");
    if (!disabled && value.length === 0 && question.isRequired) {
      setTimeout(()=>{
        setError('Required, please select an option.');
      },0) 
      if(props.isAdmin) {
        return;
      }
      throw new Error();
    }
    if(props.isAdmin) {
      dispatch(addAdminIntakeFormData( "veteran_status", Array.isArray(value) ? value[0]?.value : value?.value));
      props.handleAdminStep();
      return;
    }
    if (!disabled) {
       dispatch(addIntakeQuestions(userId, { veteran_status: Array.isArray(value) ? value[0]?.value : value?.value },"veteran_status"));
    }
  };

  const handleOnChange = event => {
    if (event) {
      setValue(event);
    } else {
      setValue([]);
    }
  };

  return (
    <TravelerFormQuestionContainer 
      isAdmin={props.isAdmin} 
      question={question} 
      handleBackStep={()=>props.handleAdminBackStep()} 
      adminIntakeStep={props.adminIntakeStep}
      handleNext={handleNext} disabled={disabled} canBeSynced>
      <SelectInput
        value={value}
        defaultValue={value}
        id="veteran_status"
        label="Veteran"
        placeholder="Select veteran status"
        options={options}
        error={error}
        disabled={disabled}
        required = {question.isRequired}
        handleOnChange={handleOnChange}
      />
    </TravelerFormQuestionContainer>
  );
}
